import React, {useEffect, useState} from 'react'
import {Container, Grid} from "@mui/material"
import {returnQRCodeParameters} from "./utils/parsingFunctions";
import DebugMenu from "./debug/DebugMenu";
import Loading from "./components/Loading";
import Error from "./components/Error";
import TemplateSecret from "./templates/secretStory/TemplateSecret";
import {AppState, TF1AppState, TF1QRPayload} from "./interfaces/interfaces";
import TemplateStarAc from "./templates/starAcademy/TemplateStarAc";

const {REACT_APP_ENV} = process.env

export default function App() {

    // loading and errors
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<boolean>(false);
    // QR code content
    const [fieldDisplay, setFieldDisplay] = useState<TF1QRPayload>({
        phone: '',
        message: '',
    });
    const [template, setTemplate] = useState<string | undefined>("")
    const [appState, setAppState] = useState<AppState | null>(null)

    const testMode = REACT_APP_ENV !== 'production';

    const debug = () => {

        function propagateTestData() {
            setError(false)
            setTemplate("secretstory")
            setAppState(AppState.OPENED)
            setFieldDisplay({
                phone: "0601452535",
                message: "test"
            })
        }

        function propagateStarAc() {
            setError(false)
            setTemplate("staracademy")
            setAppState(AppState.OPENED)
            setFieldDisplay({
                phone: "0601452535",
                message: "test"
            })
        }

        function switchLoading() {
            setLoading(!loading)
        }

        function switchError() {
            setError(!error)
        }

        function switchAppState() {
            if (appState !== AppState.OPENED) setAppState(AppState.OPENED); else setAppState(AppState.CLOSED)
        }

        function navigateToProperURL() {
            window.location.href = "/secretstory/open?phone=0601452535&message=Bonjour les connauds ! Comment ça va dis donc?"
        }

        return {propagateTestData, switchError, switchLoading, switchAppState, navigateToProperURL, propagateStarAc}

    }

    useEffect(() => {
        fetchQRCodeData().then((result) => {
            if (!result) {
                setError(true)
                return;
            }

            setTemplate(result.domain)
            // Set app state
            setAppState(result.appState)
            // Set fields
            setFieldDisplay({
                message: !!result.payload.message ? result.payload.message : "",
                phone: result.payload.phone,
            })

        }).finally(() => {
            setLoading(false);
        })
    }, [])

    // Fetch QR Code data
    const fetchQRCodeData = async (): Promise<TF1AppState | null> => {
        return await returnQRCodeParameters()
    }

    // Show the correct UI
    const typeDisplay = () => {

        if (error) return <></>

        switch (template) {
            case 'secretstory': return <TemplateSecret {...{fieldDisplay, appState}} />
            case 'staracademy': return <TemplateStarAc {...{fieldDisplay, appState}} />
            default: return <></>;
        }
    }

    return (
        <Container maxWidth={false} sx={{padding: "0px!important"}}>

            <DebugMenu {...{
                testMode,
                fieldDisplay,
                template,
                debug
            }} />

            <Grid container justifyContent={"center"}>
                {loading ? <Loading/> : error ? <Error/> : typeDisplay()}
            </Grid>
        </Container>
    );
}
